import { useState, useContext } from "react";
import "../../Style/actionstyle.scss";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { AuthContext } from "../../Context/AuthContext"; 
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import ShiftForm from "./ShiftForm";
import DeleteShift from "./DeleteShift";

export default function ShiftAction({ editData, setRefetch }) {
  // Change Language
  const { t } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openEdit && (
        <ShiftForm
          dialogTitle={"Update"}
          open={openEdit}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}

      {openDel && (
        <DeleteShift
          open={openDel}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseDel}
        />
      )}
    </div>
  );
}
